module.exports = __webpack_public_path__ + "img/offline-heading.1bdd0c30.svg";